module.exports = __webpack_public_path__ + "static/media/img_24.9200741f.JPG";